import React from 'react'
import { connect } from 'react-redux'
import UserActions from '../../Redux/UserRedux'

class DeleteAdmin extends React.Component {

  _submit = (event) => {
    event.preventDefault()
    this.props.deleteUser(this.props.detail.id)
    this.props.closeModal()
  }

  render () {
    const { detail } = this.props
    let name = '-'
    if (detail.first_name || detail.last_name) {
      name = detail.first_name + ' ' + detail.last_name
    }
    return (
      <div className="section" style={{ width: '40vw' }}>
        <div className="title-block">
          <h4 className="title mr-auto">Delete { name }?</h4>
        </div>

        <form onSubmit={(event) => this._submit(event)}>
          <div className="form-group text-center">
            <button type="button" className="btn btn-lg btn-secondary mr-2" onClick={() => this.props.closeModal()}>Close</button>
            <button
              className="btn btn-lg btn-danger"
              type="submit"
            >
              Delete
            </button>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  deleteUser: (id) => dispatch(UserActions.userDeleteRequest(id))
})

export default connect(stateToProps, dispatchToProps)(DeleteAdmin)


// WEBPACK FOOTER //
// ./src/Containers/ManageAdmin/DeleteAdmin.js